function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["position", "classes", "visible", "type", "children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import Alert from "../Alert/index.js";
var DEFAULT_WAIT_TIME = 3000; /* 3 seconds */
var _timeout = /*#__PURE__*/new _WeakMap();
var ControlledAlert = /*#__PURE__*/function (_React$Component) {
  _inherits(ControlledAlert, _React$Component);
  var _super = _createSuper(ControlledAlert);
  function ControlledAlert() {
    var _this;
    _classCallCheck(this, ControlledAlert);
    _this = _super.apply(this, arguments);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _timeout, {
      writable: true,
      value: null
    });
    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: _this.props.visible,
      content: _this.props.children,
      type: _this.props.type
    });
    return _this;
  }
  _createClass(ControlledAlert, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Avoid calling setState when unmounted
      clearTimeout(_classPrivateFieldGet(this, _timeout));
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.state.visible;
    }
  }, {
    key: "show",
    value: function show(_ref) {
      var content = _ref.content,
        type = _ref.type;
      this.setState({
        content: content,
        type: type,
        visible: true
      });
    }
  }, {
    key: "showAndDismiss",
    value: function showAndDismiss() {
      var _this2 = this;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref2.type,
        content = _ref2.content,
        _ref2$waitTime = _ref2.waitTime,
        waitTime = _ref2$waitTime === void 0 ? DEFAULT_WAIT_TIME : _ref2$waitTime;
      this.show({
        type: type,
        content: content
      });
      _classPrivateFieldSet(this, _timeout, _setTimeout(function () {
        _this2.dismiss();
      }, waitTime));
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        position = _this$props.position,
        classes = _this$props.classes,
        visible = _this$props.visible,
        type = _this$props.type,
        children = _this$props.children,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Alert, _extends({
        visible: this.state.visible,
        type: this.state.type,
        position: position,
        classes: classes
      }, rest), this.state.content);
    }
  }]);
  return ControlledAlert;
}(React.Component);
export { ControlledAlert as default };
process.env.NODE_ENV !== "production" ? ControlledAlert.propTypes = {
  /**
   * Hydrate initial visibility state (useful for server side rendering)
   */
  visible: PropTypes.bool,
  /**
   * Hydrate initial content (useful for server side rendering)
   */
  children: PropTypes.node,
  /**
   * Hydrate initial type (useful for server side rendering)
   */
  type: PropTypes.oneOf(['error', 'info']),
  /**
   * Position in container
   */
  position: PropTypes.oneOf(['top', 'bottom']),
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'is-visible', 'is-not-visible', 'type-error', 'type-info', 'position-top', 'position-bottom'])
} : void 0;